import React, { useEffect, useState } from 'react';

import { checkImageUrl, getInitialsFromFullName } from 'libs/utils';

import { Fonts } from 'styles/theme';
import { InitialsWrapper, AvatarImage } from 'styles/profiles';
interface AvatarProps {
    fullName: string;
    imageUrl?: string | null;
    size?: 'small' | 'large' | 'xLarge';
}

export const Avatar = ({ fullName, imageUrl, size }: AvatarProps) => {
    const [isImageValid, setIsImageValid] = useState<boolean>(false);

    useEffect(() => {
        const validateImage = async () => {
            if (imageUrl && imageUrl !== '') {
                const valid = await checkImageUrl(imageUrl);
                setIsImageValid(valid);
            } else {
                setIsImageValid(false);
            }
        };
        validateImage();
    }, [imageUrl]);

    return imageUrl == null || imageUrl === '' || !isImageValid ? (
        <InitialsWrapper $size={size}>
            <Fonts.Small>{getInitialsFromFullName(fullName)}</Fonts.Small>
        </InitialsWrapper>
    ) : (
        <AvatarImage src={imageUrl} alt="avatar" $size={size} />
    );
};
